import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GradientHeading } from "@/components/ui/gradient-heading";
import { SEOPageMeta } from "@/components/SEOPageMeta";
import { SEOBreadcrumbSchema } from "@/components/SEOBreadcrumbSchema";
import { useNavigate } from "react-router-dom";
const Managementleistungen = () => {
  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.querySelector('#contact');
      contactSection?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  return <div className="min-h-screen">
      <SEOPageMeta 
        title="Interim Management & Unternehmensberatung Hotellerie"
        description="Expertise für Ihren Erfolg: Interim Management, Coaching, Unternehmensberatung und Trainings für Hotels & Restaurants. Nachhaltige Lösungen für die Gastronomie."
        path="/managementleistungen"
        keywords={["Interim Management Hotellerie", "Unternehmensberatung Gastronomie", "Coaching Führungskräfte", "Hotel Consulting", "Gastronomie Beratung"]}
      />
      <SEOBreadcrumbSchema items={[
        { name: "Home", path: "/" },
        { name: "Managementleistungen", path: "/managementleistungen" }
      ]} />
      <Header />
      <main>
        {/* Enhanced Hero Section - Mobile Optimized */}
        <section className="relative h-screen flex items-center justify-center overflow-hidden">
          {/* Enhanced Background with Depth */}
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-elegant opacity-90" />
            
            {/* Layered Background Elements - Mobile Responsive */}
            <div className="absolute top-1/4 right-1/4 w-48 h-48 sm:w-96 sm:h-96 rounded-full blur-3xl opacity-40" style={{
            background: 'radial-gradient(circle, hsl(210 65% 32% / 0.1) 0%, transparent 70%)'
          }} />
            <div className="absolute bottom-1/3 left-1/3 w-32 h-32 sm:w-64 sm:h-64 rounded-full blur-2xl opacity-30" style={{
            background: 'radial-gradient(circle, hsl(210 65% 32% / 0.08) 0%, transparent 70%)'
          }} />
            
            {/* Subtle Grid Pattern */}
            <div className="absolute inset-0 opacity-[0.015]" style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, hsl(210 65% 32%) 1px, transparent 0)`,
            backgroundSize: '30px 30px'
          }} />
          </div>
          
          <div className="relative z-10 container mx-auto px-4 sm:px-8 text-center">
            <div className="max-w-4xl mx-auto animate-fade-in">
              <div className="mb-6 sm:mb-8">
                <div className="flex items-center justify-center space-x-3 sm:space-x-4 mb-4 sm:mb-6">
                  <span className="w-12 sm:w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
                  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full" style={{
                  backgroundColor: 'hsl(210 65% 32%)'
                }}></div>
                  <span className="w-12 sm:w-16 h-px bg-gradient-to-r from-transparent via-primary to-transparent"></span>
                </div>
                <p className="font-medium tracking-wider uppercase text-xs sm:text-sm mb-4 sm:mb-6" style={{
                color: 'hsl(210 65% 32%)'
              }}>MANAGEMENTLEISTUNGEN</p>
              </div>

              <h1 className="text-3xl sm:text-5xl md:text-7xl font-display font-extralight mb-6 sm:mb-8 leading-tight px-4 sm:px-0">
                <span className="bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent">
                  Expertise
                </span>
                <span className="block text-2xl sm:text-4xl md:text-5xl font-light mt-2 sm:mt-4" style={{
                color: 'hsl(210 65% 32%)'
              }}>
                  für Ihren Erfolg
                </span>
              </h1>
              
              <div className="max-w-3xl mx-auto mb-8 sm:mb-12 relative px-4 sm:px-0">
                <div className="hidden sm:block absolute -left-6 top-0 w-1 h-full bg-gradient-to-b from-transparent via-primary to-transparent opacity-30"></div>
                <p className="text-base sm:text-xl text-muted-foreground leading-relaxed font-light">
                  Ob Interim Management, Unternehmensanalyse oder das zielgerichtete Entwickeln Ihrer Unternehmensstrategie – unser Expertenteam begleitet Ihr Hotel oder Restaurant nachhaltig.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4 sm:px-0">
                <Button variant="default" size="lg" className="font-medium text-base sm:text-lg px-8 sm:px-10" onClick={handleContactClick}>
                  Beratung anfragen
                </Button>
                
              </div>
            </div>
          </div>
        </section>

        {/* Services Overview */}
        <section className="py-16">
          <div className="container mx-auto px-6 max-w-7xl">
            <div className="grid md:grid-cols-2 gap-8">
              <Card className="p-8 border border-border/40 shadow-luxury bg-background/80 backdrop-blur-md hover:shadow-story transition-all duration-300">
                <div className="space-y-4">
                  <h3 className="text-xl font-display font-medium text-foreground">
                    Interim Management
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Durch unser professionelles und gezieltes Interim Management Programm wird aus der Problemstellung „Vakanz" schnell eine Chance. Experten analysieren und decken vorhandene Problematiken bei Ihnen vor Ort auf.
                  </p>
                  <Button variant="outline" size="sm" className="mt-4" asChild>
                    <a href="#interim-management">Mehr erfahren</a>
                  </Button>
                </div>
              </Card>

              <Card className="p-8 border border-border/40 shadow-luxury bg-background/80 backdrop-blur-md hover:shadow-story transition-all duration-300">
                <div className="space-y-4">
                  <h3 className="text-xl font-display font-medium text-foreground">
                    Perspektivisches Coaching
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Wir bieten ein individuelles Coaching für Führungskräfte der Hotellerie & Gastronomie an. Im Gegensatz zur klassischen Schulung geht das Coaching unter Wahrung völliger Diskretion gezielt auf die Bedürfnisse des Einzelnen ein.
                  </p>
                  <Button variant="outline" size="sm" className="mt-4" asChild>
                    <a href="#coaching">Mehr erfahren</a>
                  </Button>
                </div>
              </Card>

              <Card className="p-8 border border-border/40 shadow-luxury bg-background/80 backdrop-blur-md hover:shadow-story transition-all duration-300">
                <div className="space-y-4">
                  <h3 className="text-xl font-display font-medium text-foreground">
                    Unternehmens- und Projektmanagement
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Die Sicht auf ein Unternehmen von außen zeigt oft Wege, die dem Blick von innen verborgen bleiben. Gemeinsam beleuchten wir Ihr Unternehmen aus einer neuen Perspektive und entwickeln zukunftsweisende Strategien.
                  </p>
                  <Button variant="outline" size="sm" className="mt-4" asChild>
                    <a href="#unternehmensberatung">Mehr erfahren</a>
                  </Button>
                </div>
              </Card>

              <Card className="p-8 border border-border/40 shadow-luxury bg-background/80 backdrop-blur-md hover:shadow-story transition-all duration-300 md:col-span-2 lg:col-span-1">
                <div className="space-y-4">
                  <h3 className="text-xl font-display font-medium text-foreground">
                    Trainings und Workshops
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Trainings und Workshops sind so unterschiedlich wie die Menschen, die sie besuchen. Erfahren Sie mehr über unsere individuellen Trainingsprogramme. Wir vermitteln Wissen in den Bereichen, die speziell für Ihr Unternehmen relevant sind.
                  </p>
                  <Button variant="outline" size="sm" className="mt-4" asChild>
                    <a href="#training">Mehr erfahren</a>
                  </Button>
                </div>
              </Card>
            </div>
          </div>
        </section>

        {/* Detailed Services */}
        <section className="py-20 bg-gradient-subtle">
          <div className="container mx-auto px-6 max-w-6xl space-y-20">
            
            {/* Interim Management */}
            <div id="interim-management" className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <div className="space-y-4">
                  <GradientHeading size="lg">
                    Potenziale erkennen durch 
                    <span className="block">Interim Management</span>
                  </GradientHeading>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    Sie haben eine Vakanz und möchten diese nicht direkt neu besetzen? Ihr Hotel oder Restaurant läuft nicht rund oder Sie möchten durch eine Anpassung Ihrer Strategie neue Wege gehen?
                  </p>
                  <p className="text-base text-muted-foreground">
                    In solch einem Fall ist eine Interim-Lösung oft ideal.
                  </p>
                </div>
              </div>
              <Card className="p-8 lg:p-10 border border-border/40 shadow-luxury bg-background/90 backdrop-blur-md">
                <div className="space-y-6">
                  <p className="text-muted-foreground leading-relaxed">
                    Als Manager auf Zeit tauchen unsere Experten in Ihr Unternehmen ein. Dabei fokussieren sie sich auf das Überbrücken temporärer Vakanzen, aber auch auf das Aufspüren spezieller Herausforderungen. Als Interim-Manager übernehmen diese dabei operative als auch strategische Verantwortung.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    Interim Management bedeutet für Scholz Interim nicht nur das Entsenden eines Managers auf Zeit. Unser Expertenteam ist in regelmäßigem Austausch mit dem gestellten Interim Manager um somit ein Maximum an Weitblick, einer 360° Betrachtung der Situation, sicherzustellen.
                  </p>
                  <Button variant="premium" className="mt-6" onClick={handleContactClick}>
                    Kontakt aufnehmen
                  </Button>
                </div>
              </Card>
            </div>

            {/* Coaching */}
            <div id="coaching" className="grid lg:grid-cols-2 gap-12 items-center">
              <Card className="p-8 lg:p-10 border border-border/40 shadow-luxury bg-background/90 backdrop-blur-md lg:order-1">
                <div className="space-y-6">
                  <p className="text-muted-foreground leading-relaxed">
                    Im Gegensatz zur klassischen Schulung geht das Coaching unter Wahrung völliger Diskretion gezielt auf die speziellen Bedürfnisse des Einzelnen ein. Warum ist absolute Verschwiegenheit so wichtig? Weil der Erfolg jeden Coachings vom Bereitstellen und Bewerten aller relevanten Parameter der jeweiligen Problemstellung abhängt.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    Beim Coaching müssen persönliche UND berufliche Herausforderungen in vertrauten Rahmen besprochen, gemeinsame Lösungen gefunden und neue Verhaltensweisen in tägliche Prozessabläufe integriert werden.
                  </p>
                  <Button variant="premium" className="mt-6" onClick={handleContactClick}>
                    Coaching anfragen
                  </Button>
                </div>
              </Card>
              <div className="space-y-6 lg:order-2">
                <div className="space-y-4">
                  <GradientHeading size="lg">
                    Gemeinsam Lösungen finden durch
                    <span className="block">Perspektivisches Coaching</span>
                  </GradientHeading>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    Das Geheimrezept für ein erfolgreiches Coaching? Die gecoachte Person muss die Bereitschaft mitbringen, sich zu öffnen und kooperativ etwas verändern zu wollen, um die eigenen Zielvorstellungen erfüllen zu können.
                  </p>
                </div>
              </div>
            </div>

            {/* Unternehmensberatung */}
            <div id="unternehmensberatung" className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <div className="space-y-4">
                  <GradientHeading size="lg">
                    Wir wechseln die Perspektive
                    <span className="block">Unternehmensberatung</span>
                  </GradientHeading>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    Bei Generationswechsel, dem Zentralisieren von Prozessen, bei Kosten-Nutzenanalysen oder auch bei einer umfassenden Organisationsentwicklung – unser Projektteam begleitet Sie durch Ihren Change Prozess.
                  </p>
                </div>
              </div>
              <Card className="p-8 lg:p-10 border border-border/40 shadow-luxury bg-background/90 backdrop-blur-md">
                <div className="space-y-6">
                  <p className="text-muted-foreground leading-relaxed">
                    Nachhaltige Unternehmensberatung beginnt mit dem detaillierten Erarbeiten der Problemstellung Ihres Unternehmens. Persönlich, offen und durch fundiertes Fachwissen legitimiert, beginnen wir mit der Analyse Ihrer gegenwärtigen Situation.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    Sie als Unternehmen sehen dabei nicht nur zu. Sie sind vielmehr wesentlicher Bestandteil und aktiver Teilnehmer beim Herausarbeiten Ihrer Ist-Situation.
                  </p>
                  <Button variant="premium" className="mt-6" onClick={handleContactClick}>
                    Beratung anfragen
                  </Button>
                </div>
              </Card>
            </div>

            {/* Training */}
            <div id="training" className="grid lg:grid-cols-2 gap-12 items-center">
              <Card className="p-8 lg:p-10 border border-border/40 shadow-luxury bg-background/90 backdrop-blur-md lg:order-1">
                <div className="space-y-6">
                  <p className="text-muted-foreground leading-relaxed">
                    Als lizensierte Trainer wenden wir bei unseren Seminaren methodisch und didaktisch stets die neuesten Techniken an. Dabei bedienen wir uns jedoch nicht eines Standardschulungsprogramms.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    Im Rahmen eines ersten Gespräches mit Ihnen ermitteln wir den Bedarf und entwickeln dann Ihr individuelles Seminar & Trainingsprogramm.
                  </p>
                  <Button variant="premium" className="mt-6" onClick={handleContactClick}>
                    Training planen
                  </Button>
                </div>
              </Card>
              <div className="space-y-6 lg:order-2">
                <div className="space-y-4">
                  <GradientHeading size="lg">
                    Im Team lernen, sich gemeinsam entwickeln
                    <span className="block">Trainings & Workshops</span>
                  </GradientHeading>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    So individuell wie Ihr Unternehmen sind auch die Menschen, die für Sie arbeiten. Wir finden die maßgeschneiderten Lösungen Ihre Mitarbeitenden zu schulen und zu entwickeln.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="container mx-auto px-6 max-w-4xl text-center">
            <div className="space-y-8">
              <h2 className="text-4xl lg:text-5xl font-display font-light text-foreground">
                Bereit für den nächsten Schritt?
              </h2>
              <p className="text-xl text-muted-foreground leading-relaxed">
                Sprechen Sie uns an. Gemeinsam erörtern wir die IST-Situation und finden Wege in Ihre erfolgreiche berufliche und private Zukunft.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button variant="premium" size="lg" className="font-display" onClick={handleContactClick}>
                  Kontakt aufnehmen
                </Button>
                <Button variant="outline" size="lg" className="font-display" asChild>
                  <a href="tel:+4941414263112">Telefonisch beraten lassen</a>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>;
};
export default Managementleistungen;